<template>
  <div class="flex flex-col w-full space-y-10">
    <div class="flex items-center lg:flex-col space-x-4 lg:space-x-0 lg:space-y-4">
      <div class="flex flex-col w-1/2 lg:w-full">
        <h2 class="text-32px xs:text-2xl font-bold text-left mb-5">
          {{ $t('video_interview.current-step', {
            currentStep: currentStep,
            maxStep: maxStep
          }) }}
        </h2>
        <div class="text-neutral-50 text-base text-left mb-5">
          {{ $t('video_interview.prepering-to-recording', { seconds: questions[currentStep - 1].preparationTime }) }}
        </div>
        <div v-if="showQuestion === currentStep" class="text-neutral-50 text-base xs:text-sm text-left mb-5">
          {{ $t('video_interview.question-text') }}
          <p v-html="questions[currentStep - 1].description"></p>
        </div>
        <Button
          v-else
          @click="showNextQuestion"
        >
          {{ $t('video_interview.question-text') }}
        </Button>
      </div>
      <VideoRecorder
        ref="recorder"
        class="w-1/2 lg:w-full"
        :disabled-record="showQuestion !== currentStep"
        without-skip
        @record-started="onStart"
        @finish-video-record="onFinish"
      />
    </div>
  </div>
</template>
<script>
import VideoRecorder from '@/components/Global/VideoRecorder.vue';
import Button from '@/components/UI/Button.vue';

export default {
  name: 'Interview',
  components: {
    VideoRecorder,
    Button,
  },
  props: {
    questions: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      currentStep: 1,
      showQuestion: 0,
      preparationInterval: null,
    };
  },
  computed: {
    maxStep() {
      return this.questions.length;
    },
  },
  methods: {
    onFinish(v) {
      this.$emit('send-answer', { file: v, questionId: this.questions[this.currentStep - 1].id });
      this.currentStep += 1;
      if (this.currentStep > this.maxStep) {
        this.$emit('finish-interview');
      }
    },
    showNextQuestion() {
      this.showQuestion += 1;
      if (this.questions[this.currentStep - 1].preparationTime === 0) {
        return;
      }
      this.preparationInterval = setInterval(() => {
        this.questions[this.currentStep - 1].preparationTime -= 1;
        if (this.questions[this.currentStep - 1].preparationTime === 0) {
          clearInterval(this.preparationInterval);
          this.$refs.recorder.startRecord();
        }
      }, 1000);
    },
    onStart() {
      clearInterval(this.preparationInterval);
    },
  },
};
</script>
<style lang="scss"></style>
